const REQUEST_EDIT_SUFFIX = /^\/request\/edit\//

export const resolveSingleCommunityProjectRedirect = (
  communityIds: number[] | null | undefined,
  projectId: number,
  pathname: string,
): string | null => {
  if (!communityIds || communityIds.length !== 1) return null

  const match = pathname.match(new RegExp(`/project/${projectId}(/.*)?$`))
  if (!match) return null

  const suffix = match[1] ?? ""
  if (REQUEST_EDIT_SUFFIX.test(suffix)) return null

  return `/community/${communityIds[0]}/project/${projectId}${suffix}`
}
